import { render, staticRenderFns } from "./CollectionCount.vue?vue&type=template&id=1de44b5a&"
import script from "./CollectionCount.vue?vue&type=script&lang=js&"
export * from "./CollectionCount.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports